import CreateBookingPreferenceDto from '../../dto/booking-preferences/in/save-booking-preference.dto';
import { apiV1 } from '../../http';
import { axiosHttpErrorToError } from '../../utils/errors';

class SaveBookingPreferenceService {
  async save(dto: CreateBookingPreferenceDto): Promise<void> {
    try {
      const method = !dto.id ? 'POST' : 'PUT';

      await apiV1.request<void>({
        url: '/booking-preferences/me',
        data: dto,
        method,
      });
    } catch (error) {
      throw axiosHttpErrorToError(error);
    }
  }
}

export default SaveBookingPreferenceService;
